<section class="benefits" aria-labelledby="who-benefits-title">
  <div class="benefits--container">
    <div class="benefits--header">
      <span class="benefits--accent" aria-hidden="true"></span>
      <h2 id="who-benefits-title" class="benefits--title">Who Benefits</h2>
      <span class="benefits--line" aria-hidden="true"></span>
    </div>

    <div class="benefits--grid">
      @for (benefit of benefits; track benefit.id) {
        <article class="benefit-card">
          <div class="benefit-card--icon">
            <img [src]="benefit.icon" [alt]="benefit.title" class="benefit-card--icon-img" />
          </div>
          <div class="benefit-card--text">
            <h3 class="benefit-card--title">{{ benefit.title }}</h3>
            <p class="benefit-card--description">{{ benefit.description }}</p>
          </div>
        </article>
      }
    </div>
  </div>
</section>
